import React, { Component } from 'react';
import moment from 'moment';
import { SUNDAY, THURSDAY, PREMIUM_ROOM_TYPE_GROUPS } from 'utils/constants';
import DayWithMinimumRate from './DayWithMinimumRate';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import size from 'lodash/size';
import { RACK_RATE, CLOSED } from 'utils/constants';
import { hotelCalendarDayShape } from 'utils/shapes';
import { isWebOfferPrizeCode } from 'utils/rewards';

class DayTile extends Component {
  renderDayWithMinimumRate = (isCompable, dayOffers) => {
    const {
      startDate,
      endDate,
      selectedOffers,
      hotelCalendarDay,
      minimumRate,
      isSelected,
      rackRate,
      useRackRate,
      roomType,
      isHostBooking,
      hotelOverrideCodes
    } = this.props;

    const day = moment(hotelCalendarDay.date);
    const appliedOffer =
      startDate && endDate ? selectedOffers[hotelCalendarDay.date] : null;
    const hasOffer = dayOffers.length > 0;
    const isCheckoutDate =
      endDate && moment(hotelCalendarDay.date).isSame(moment(endDate), 'day');

    const offer = appliedOffer ? appliedOffer : dayOffers[0];
    const showPrizeCode = !startDate || !endDate || !!appliedOffer;
    const prizeCode =
      showPrizeCode && offer ? offer.patronReward.prizeCode : '';
    const isSuite = PREMIUM_ROOM_TYPE_GROUPS.includes(roomType.value);
    const hasWebOffer =
      !isSuite &&
      isWebOfferPrizeCode(prizeCode) &&
      day.day() >= SUNDAY &&
      day.day() <= THURSDAY;
    const hasOverrideCode =
      hotelOverrideCodes &&
      hotelOverrideCodes.some(
        code =>
          prizeCode === code.hotelCode &&
          day.isBetween(
            moment(code.startDate).startOf('day'),
            moment(code.endDate).startOf('day'),
            undefined,
            []
          )
      );

    return (
      <DayWithMinimumRate
        isCheckoutDate={isCheckoutDate}
        isCompable={isCompable}
        isSelected={isSelected}
        hasOffer={hasOffer}
        minimumRate={minimumRate}
        prizeCode={prizeCode}
        showPrizeCode={showPrizeCode}
        offer={offer}
        rackRate={rackRate}
        useRackRate={useRackRate}
        hasWebOffer={hasWebOffer}
        isHostBooking={isHostBooking}
        hasAvailability={hotelCalendarDay.hasAvailability}
        hotelOverrideCodes={hotelOverrideCodes}
        hasOverrideCode={hasOverrideCode}
      />
    );
  };

  render() {
    const {
      minimumRate,
      hotelCalendarDay,
      isCompable,
      endDate,
      isHostBooking
    } = this.props;
    const dayOffers =
      hotelCalendarDay && hotelCalendarDay.roomRates.length > 0
        ? hotelCalendarDay.roomRates[0].offers || []
        : [];

    const hasOffer = dayOffers.length > 0;
    const comped = isCompable && hasOffer;
    const isCheckoutDate =
      endDate &&
      hotelCalendarDay &&
      moment(hotelCalendarDay.date).isSame(moment(endDate), 'day');

    const hotelClosed =
      hotelCalendarDay &&
      hotelCalendarDay.restrictions.length > 0 &&
      size(
        filter(hotelCalendarDay.restrictions, restriction => {
          return (
            restriction &&
            restriction.rateCode === RACK_RATE &&
            restriction.restrictionType === CLOSED
          );
        })
      ) > 0;

    const showSoldOut = isHostBooking || hotelCalendarDay?.hasAvailability;

    return (
      <div className="content">
        <div className={`rate ${comped ? 'comp' : ''}`}>
          {hotelCalendarDay?.missingRackRates ? (
            <span className="unavailable">UNAVAILABLE</span>
          ) : showSoldOut && (minimumRate || isCheckoutDate) && !hotelClosed ? (
            this.renderDayWithMinimumRate(isCompable, dayOffers)
          ) : (
            <span className="unavailable">SOLD OUT</span>
          )}
        </div>
      </div>
    );
  }
}

DayTile.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  hotelCalendarDay: hotelCalendarDayShape,
  selectedOffers: PropTypes.object,
  roomType: PropTypes.object,
  minimumRate: PropTypes.number,
  isSelected: PropTypes.bool,
  rackRate: PropTypes.number,
  useRackRate: PropTypes.bool,
  isCompable: PropTypes.bool,
  isHostBooking: PropTypes.bool,
  hotelOverrideCodes: PropTypes.shape({
    id: PropTypes.number,
    hotelCode: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    lastModified: PropTypes.string
  })
};

export default DayTile;
